import {
  Button,
  Pagination,
  Table,
  Tag,
  Input,
  Popconfirm,
  message,
} from "antd";
import React, { useEffect, useState } from "react";
import {
  ExtractDate,
  ExtractTime,
  getLocalStorageItem,
  messageConfiguration,
} from "../../../utils";
import { useLocation } from "react-router-dom";
import ComponentTitle from "../../../Common/ComponentTitle";
import { DeleteOutlined } from "@ant-design/icons";
import {
  deleteSubscriptionData,
  getExportData,
  getSubscriptionData,
} from "./SubscriptionApiFunction";
import { getAPIUrl } from "../../../services/apiMethod";
import axios from "axios";
import { saveAs } from "file-saver";
const SubscriptionDetails = () => {
  const [SubscriptionData, setSubcriptionData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [totalPage, setTotalPages] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const { Search } = Input;
  const location = useLocation();
  const from = location.state?.from;
  const pageSize = 10;

  function FetchSubscriptionDetails(currentPage) {
    setIsLoading(true);
    getSubscriptionData(`?search=${searchTerm}&page=${currentPage}&limit=10`)
      // `isActive=1&isApproved=${approved}&isRejected=${rejected}&request_name=${searchTerm}&page=${currentPage}`
      .then((response) => {
        if (response.status) {
          setSubcriptionData(response.data?.data?.blogs);
          setCurrentPage(response.data?.data?.currentPage);
          setTotalPages(response.data?.data?.totalPages);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("error", err);
        setIsLoading(false);
      });
  }

  useEffect(() => {
    FetchSubscriptionDetails(currentPage);
  }, [currentPage, searchTerm]);

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
  };
  function DeleteAction(checked, record) {
    let payload = {
      subscribeId: record.id,
    };
    deleteSubscriptionData(payload)
      .then((response) => {
        if (response.data.status) {
          message.open(
            messageConfiguration("success", response.data.message, 3)
          );
          FetchSubscriptionDetails(currentPage);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  const columnReports = [
    {
      title: "SNo.",
      dataIndex: "serial",
      key: "serial",
      className: "custom-header font-poppins text-xs",
      render: (data, record, index) => {
        return (
          <p className="text-xs font-poppins text-rgbaprimary9 font-semibold">
            {index + 1 + (currentPage - 1) * pageSize}.
          </p>
        );
      },
    },

    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => {
        return (
          <>
            <p className="text-xs font-poppins">{record?.email ?? "--"}</p>
          </>
        );
      },
    },

    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => {
        return (
          <>
            <p className="text-xs font-poppins">
              {ExtractDate(record.createdAt)}.{ExtractTime(record.createdAt)}
            </p>
          </>
        );
      },
    },
    {
      title: "Delete",
      dataIndex: "delete",
      key: "delete",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => (
        <Popconfirm
          title={
            <div>
              <p style={{ marginBottom: "8px", fontWeight: "bold" }}>
                Are you sure you want to delete this Contact?
              </p>
            </div>
          }
          onConfirm={() => DeleteAction(undefined, record)}
          okText="Delete"
          cancelText="Cancel"
        >
          <DeleteOutlined
            className="text-xs font-poppins font-bold w-1/2 text-center rounded-full cursor-pointer text-rgbaprimary9"
            title="Delete"
          />
        </Popconfirm>
      ),
    },
  ];


  const handleExport = () => {
    const apiendpoint = `${process.env.REACT_APP_BASE_URL}admin/get-subscription-excel`;

    axios
      .get(apiendpoint, {
        responseType: "blob",
        headers: {
          Accept: "text/csv", // or "application/csv" if your backend uses that
          Authorization: `Bearer ${getLocalStorageItem("token")}`,
        },
      })
      .then((res) => {
        const blob = new Blob([res.data], { type: "text/csv;charset=utf-8;" });
        saveAs(blob, "subscription_data.csv"); // custom filename
      })
      .catch((err) => console.error("Export failed:", err));
  };

  return (
    <div>
      <ComponentTitle title={"Subscription List"} />
      <div className="flex items-between justify-between m-2">
        <Search
          placeholder="search here..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ width: "25%" }}
        />
        <p
          onClick={handleExport}
          className="bg-rgbaprimary9 cursor-pointer text-white text-sm p-2 hover:bg-rgbaprimary8"
        >
          Export Subscription Data
        </p>
      </div>
      <div
        style={{ maxHeight: "540px", overflow: "auto" }}
        className="bg-white shadow-md  shadow-[rgba(149, 157, 165, 0.2) 0px 8px 24px]"
      >
        <Table
          bordered={true}
          loading={isLoading}
          columns={columnReports}
          dataSource={SubscriptionData}
          pagination={false}
          className="w-screen sm:w-screen custom-table-header"
          size="small"
        />
      </div>
      <Pagination
        className="mt-2 text-xs w-full flex justify-center items-center"
        onChange={handlePageChange}
        current={currentPage}
        defaultCurrent={1}
        pageSize={pageSize}
        total={10 * totalPage}
        showSizeChanger={false}
      />
    </div>
  );
};
export default SubscriptionDetails;
